import React, { useRef } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    oneTimeWorkoutFormAction,
    selectAction,
    userFormAction
} from "../../redux/rootReducer";
import {
    getUsersForSubscriptionSagaAction,
    recordOneTimeWorkoutSagaAction
} from "../../redux/sagaActions";
import getCost from "../../helpers/getCost";
import Payment from "../Payment/Payment";
import { ONE_TIME_WORKOUT_FORM_INITIAL, SELECT_INITIAL, USER_FORM_INITIAL } from "../../redux/initialStateConstant";
import Select from "../Select/Select";
import Checkbox from "../Checkbox/Checkbox";

const OneTimeWorkoutForm = () => {
    const history = useHistory();
    const dispatch = useDispatch();

    const oneTimeWorkoutForm = useSelector(state => state.oneTimeWorkoutForm);
    const subscription_coaches = useSelector(state => state.subscription_coaches);
    const subscription_types = useSelector(state => state.subscription_types);

    // Таймер для отсрочки запроса посетителей на сервере
    const timer = useRef(0);

    const getUsers = text => {

        if (timer.current) clearTimeout(timer.current);

        if (!text.trim()) {
            dispatch(oneTimeWorkoutFormAction({
                ...oneTimeWorkoutForm,
                user: { id: '', name: '', sum: '', subscriptions: '' },
                users: [],
                userInput: ''
            }));
            return false;
        }

        // Делаем задержку для набора текста
        timer.current = setTimeout(() => {
            dispatch(getUsersForSubscriptionSagaAction({ text, type: 'one_time' }));
        }, 500);
    };

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close"
                            onClick={ () => dispatch(oneTimeWorkoutFormAction(ONE_TIME_WORKOUT_FORM_INITIAL)) }
                        />
                        <div className="form__title">Разовое посещение</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Посетитель (почта или телефон)</div>
                        <div className="dropdown">
                            <input type="text" className="input"
                                   value={
                                       oneTimeWorkoutForm.user?.name ||
                                       oneTimeWorkoutForm.userInput || ''
                                   }
                                   onInput={ event => {
                                       dispatch(oneTimeWorkoutFormAction({
                                           ...oneTimeWorkoutForm,
                                           userInput: event.target.value,
                                           user: ''
                                       }));
                                       // Получение с сервера списка всех пользователей, с совпадением по email или телефону
                                       getUsers(event.target.value);
                                   } }
                            />
                            <div className={ `dropdown__items ${ oneTimeWorkoutForm.userInput ? 'dropdown__items--open' : false }` }>
                                {
                                    oneTimeWorkoutForm.users?.length
                                        ? oneTimeWorkoutForm.users.map(elem => {
                                            return (
                                                <div className="dropdown__item" key={ elem.id }
                                                     onClick={ () => {
                                                         dispatch(oneTimeWorkoutFormAction({
                                                             ...oneTimeWorkoutForm,
                                                             user: elem,
                                                             userInput: ''
                                                         }));
                                                     } }
                                                >{ `${ elem.name } ${ elem.phone }` }</div>
                                            );
                                        })
                                        : <div className="dropdown__item"
                                               onClick={ () => {
                                                   // Переходим на страницу с посетителями
                                                   history.push('/fitness/users');
                                                   // Закрываем форму добавления абонемента
                                                   dispatch(oneTimeWorkoutFormAction({
                                                       ...oneTimeWorkoutForm,
                                                       open: false
                                                   }));
                                                   // Открываем форму добавления посетителя
                                                   dispatch(userFormAction({
                                                       ...USER_FORM_INITIAL,
                                                       open: true,
                                                       title: 'Новый посетитель'
                                                   }));
                                               } }
                                        >{ `Добавить посетителя` }</div>
                                }
                            </div>
                        </div>
                        <div className="user__statistic" style={{ marginLeft: 14, marginTop: 3 }}>{ `Сумма: ${
                            oneTimeWorkoutForm?.user?.sum || 0
                        }, Абон: ${
                            oneTimeWorkoutForm?.user?.subscriptions || 0
                        }, Деп: ${ oneTimeWorkoutForm.user?.deposits || 0 }` }</div>
                    </div>
                    {
                        subscription_types.length
                            ?
                            <div className="form__field">
                                <div className="input__caption input__caption--required">Тип абонемента</div>
                                <Select
                                    current={ oneTimeWorkoutForm.type.name }
                                    type={ 'types' }
                                    options={ subscription_types.filter(el => el.hide_one_time !== '1') }
                                    handler={ elem => {
                                        dispatch(oneTimeWorkoutFormAction({
                                            ...oneTimeWorkoutForm,
                                            type: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: elem.id,
                                            coach: oneTimeWorkoutForm.coach.id,
                                            request_type: 'one_time'
                                        });
                                    } }
                                    smart={ true }
                                />
                            </div>
                            : false
                    }
                    {
                        subscription_coaches.length > 1
                            ?
                            <div className="form__field">
                                <div className="input__caption">Тренер</div>
                                <Select
                                    current={ oneTimeWorkoutForm.coach.name }
                                    type={ 'coaches' }
                                    options={ subscription_coaches }
                                    handler={ elem => {
                                        dispatch(oneTimeWorkoutFormAction({
                                            ...oneTimeWorkoutForm,
                                            coach: elem
                                        }));
                                        dispatch(selectAction(SELECT_INITIAL));
                                        getCost({
                                            dispatch,
                                            type: oneTimeWorkoutForm.type.id,
                                            coach: elem.id,
                                            request_type: 'one_time'
                                        });
                                    } }
                                    smart={ true }
                                />
                            </div>
                            : false
                    }
                    <div className="form__field form__field--flex">
                        <div className="form__inline">
                            <div className="input__caption">Дата</div>
                            <input type="date" className="input"
                                value={ oneTimeWorkoutForm.date }
                                onChange={ event => {
                                    dispatch(oneTimeWorkoutFormAction({
                                        ...oneTimeWorkoutForm,
                                        date: event.target.value
                                    }));
                                } }
                            />
                        </div>
                        <div className="form__inline">
                            <div className="input__caption">Время</div>
                            <input type="time" className="input"
                                value={ oneTimeWorkoutForm.time }
                                onChange={ event => {
                                    dispatch(oneTimeWorkoutFormAction({
                                        ...oneTimeWorkoutForm,
                                        time: event.target.value
                                    }));
                                } }
                            />
                        </div>
                    </div>
                    <Payment
                        payment={ oneTimeWorkoutForm.payment }
                        totalSum={ oneTimeWorkoutForm.total_sum }
                        discountValue={ oneTimeWorkoutForm.discount }
                        handler={ ({ payment, discount, total_sum }) => dispatch(oneTimeWorkoutFormAction({
                            ...oneTimeWorkoutForm,
                            payment,
                            discount,
                            total_sum
                        })) }
                    />
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => {
                                let formattedPayments = [];
                                // Фильтруем и форматируем платежи
                                oneTimeWorkoutForm.payment.forEach(el => {
                                    if (el.cost) {
                                        formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                    }
                                });

                                dispatch(recordOneTimeWorkoutSagaAction({
                                    user: oneTimeWorkoutForm.user?.id,
                                    type: oneTimeWorkoutForm.type?.id,
                                    coach: oneTimeWorkoutForm.coach?.id,
                                    payment: JSON.stringify(formattedPayments),
                                    discount: oneTimeWorkoutForm.discount.id,
                                    date: oneTimeWorkoutForm.date,
                                    time: oneTimeWorkoutForm.time
                                }));
                            } }
                        >Зарегистрировать</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OneTimeWorkoutForm;